import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import BreadCrumb from 'components/Common/BreadCrumb';
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, Col, Container, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import { getAlertSetting, postAlertSetting } from 'store/thunks';
import * as Yup from "yup";

const AlertSetting = () => {
  const { t, i18n } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  // const handleSubmit = async (values: any) => {
  //   if (isLoading) {
  //     return;
  //   }
  //   setIsOpen((_prev) => true);
  // };

  const handleSubmit = async (values: any) => {
    try {
      if (isLoading) {
        return;
      }

      setIsLoading((_prev) => true);

      const _data_configs = {
        alert_mode: Number(values?.alert_mode || 0),
        liquidity_rate_change: Number(values?.liquidity_rate_change || 0),
        number_transaction_per_min: Number(values?.number_transaction_per_min || 0),
        breakthrough_price: Number(values?.breakthrough_price || 0),
        pool_action: Number(values?.pool_action || 0),
        repeated_trading_wallet_per_hour: Number(values?.repeated_trading_wallet_per_hour || 0),
      };

      const res: any = await postAlertSetting(_data_configs);
      setIsOpen((_prev) => false);
      setIsLoading((_prev) => false);
      if (!!res?.success) {
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        toast(`${res?.message || res}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsOpen((_prev) => false);
      setIsLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    alert_mode: Yup.number().required(`${t("This is required")}`),
    liquidity_rate_change: Yup.string().required(`${t("This is required")}`),
    number_transaction_per_min: Yup.string().required(`${t("This is required")}`),
    breakthrough_price: Yup.string().required(`${t("This is required")}`),
    pool_action: Yup.number().required(`${t("This is required")}`),
    repeated_trading_wallet_per_hour: Yup.string().required(`${t("This is required")}`),
  });

  const formik = useFormik({
    initialValues: {
      alert_mode: 0,
      liquidity_rate_change: 0,
      number_transaction_per_min: 0,
      breakthrough_price: 0,
      pool_action: 0,
      repeated_trading_wallet_per_hour: 0,
    },
    validationSchema,
    onSubmit: handleSubmit,
  });


  const handleCallAllOption = async () => {
    try {
      const res: any = await getAlertSetting({});

      const _settings = res?.data;

      formik?.setFieldValue('alert_mode', Number(_settings?.alert_mode));
      formik?.setFieldValue('pool_action', Number(_settings?.pool_action));
      formik?.setFieldValue('liquidity_rate_change', _settings?.liquidity_rate_change);
      formik?.setFieldValue('number_transaction_per_min', _settings?.number_transaction_per_min);
      formik?.setFieldValue('breakthrough_price', _settings?.breakthrough_price);
      formik?.setFieldValue('repeated_trading_wallet_per_hour', _settings?.repeated_trading_wallet_per_hour);

    } catch (error: any) {
      return error;
    }
  };

  useEffect(() => {
    handleCallAllOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = `${t('Settings')} - ${t('Alert Settings')}`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Alert Settings')} pageTitle={t('Settings')} />
          <Row>
            <Col lg={12}>
              <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)', minHeight: '75dvh' }}>
                <CardBody className="pt-3 mx-3">
                  <form onSubmit={formik.handleSubmit}>
                    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                      <Row>
                        <div className="position-relative mb-3 mt-1 mt-md-0 px-2 px-md-3" style={{ border: '1px solid var(--vz-gray-200)', borderRadius: '4px', }}>
                          <Col sm={12} md={12} xl={12} className='mt-3 '>
                            <div className="form-check form-switch mb-0">
                              <Input className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="alert_mode"
                                name="alert_mode"
                                checked={!!formik?.values?.alert_mode}
                                onChange={(event: any) => formik.setFieldValue("alert_mode", Number(event?.target.checked))}
                              />
                              <Label className="form-check-label" for="alert_mode">{t('Alert Settings')}</Label>
                            </div>
                          </Col>

                          <Col sm={12} md={12} xl={12} className='mt-3'>
                            <div className="form-check form-switch mb-0">
                              <Input className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="pool_action"
                                name="pool_action"
                                checked={!!formik?.values?.pool_action}
                                onChange={(event: any) => {
                                  formik.setFieldValue("pool_action", Number(event?.target.checked))
                                }}
                              />
                              <Label className="form-check-label" for="pool_action">{t('Pool creation or deletion')}</Label>
                            </div>
                          </Col>

                          <Col sm={12} md={12} xl={12} className='mt-3'>
                            <Label htmlFor="liquidity_rate_change" className="form-label">{t('Liquidity change rate')} <span className="text-danger"> *</span></Label>
                            <div className="position-relative">
                              <div
                                style={{ bottom: 10, left: 5 }}
                                className="position-absolute fw-medium text-secondary"
                              >
                                ±
                              </div>
                              <Input
                                className="form-control"
                                id="liquidity_rate_change"
                                name="liquidity_rate_change"
                                type="text"
                                value={formik?.values?.liquidity_rate_change ?? ''}
                                placeholder={t('Liquidity change rate')}
                                onChange={(event: any) => {
                                  const input = event.target.value;
                                  const onlyNumbers = input.replace(/[^0-9.]/g, "");
                                  const s = onlyNumbers;
                                  formik.setFieldValue("liquidity_rate_change", s);
                                }}
                              />
                              <div
                                style={{ bottom: 10, right: 20 }}
                                className="position-absolute fw-medium text-secondary"
                              >
                                %
                              </div>
                            </div>
                            {formik.touched.liquidity_rate_change && formik.errors.liquidity_rate_change ? (
                              <div className="text-danger mt-2">{formik.errors.liquidity_rate_change}</div>
                            ) : null}
                          </Col>

                          <Col sm={12} md={12} xl={12} className='mt-3 '>
                            <Label htmlFor="number_transaction_per_min" className="form-label">{t('Number of transactions per unit time')} <span className="text-danger"> *</span></Label>
                            <div className="position-relative">
                              <Input
                                className="form-control"
                                id="number_transaction_per_min"
                                name="number_transaction_per_min"
                                type="text"
                                value={formik?.values?.number_transaction_per_min ?? ''}
                                placeholder={t('Number of transactions per unit time')}
                                onChange={(event: any) => {
                                  const input = event.target.value;
                                  const onlyNumbers = input.replace(/\D/g, "");
                                  const s = onlyNumbers;
                                  formik.setFieldValue("number_transaction_per_min", s);
                                }}
                              />
                              <div
                                style={{ bottom: 10, right: 20 }}
                                className="position-absolute fw-medium text-secondary"
                              >
                                {t('per minute')}
                              </div>
                            </div>
                            {formik.touched.number_transaction_per_min && formik.errors.number_transaction_per_min ? (
                              <div className="text-danger mt-2">{formik.errors.number_transaction_per_min}</div>
                            ) : null}
                          </Col>

                          <Col sm={12} md={12} xl={12} className='mt-3 '>
                            <Label htmlFor="breakthrough_price" className="form-label">{t('Breakthrough of designated price')} <span className="text-danger"> *</span></Label>
                            <div className="position-relative">
                              <Input
                                className="form-control"
                                id="breakthrough_price"
                                name="breakthrough_price"
                                type="text"
                                value={formik?.values?.breakthrough_price ?? ''}
                                placeholder={t('Breakthrough of designated price')}
                                onChange={(event: any) => {
                                  const input = event.target.value;
                                  const onlyNumbers = input.replace(/[^0-9.]/g, "");
                                  const s = onlyNumbers;
                                  formik.setFieldValue("breakthrough_price", s);
                                }}
                              />
                              <div
                                style={{ bottom: 10, right: 20 }}
                                className="position-absolute fw-medium text-secondary"
                              >
                                $
                              </div>
                            </div>
                            {formik.touched.breakthrough_price && formik.errors.breakthrough_price ? (
                              <div className="text-danger mt-2">{formik.errors.breakthrough_price}</div>
                            ) : null}
                          </Col>

                          <Col sm={12} md={12} xl={12} className='mt-3 '>
                            <Label htmlFor="repeated_trading_wallet_per_hour" className="form-label">{t('Repeated trading by specific wallet')} <span className="text-danger"> *</span></Label>
                            <div className="position-relative">
                              <Input
                                className="form-control"
                                id="repeated_trading_wallet_per_hour"
                                name="repeated_trading_wallet_per_hour"
                                type="text"
                                value={formik?.values?.repeated_trading_wallet_per_hour ?? ''}
                                placeholder={t('Repeated trading by specific wallet')}
                                onChange={(event: any) => {
                                  const input = event.target.value;
                                  const onlyNumbers = input.replace(/\D/g, "");
                                  const s = onlyNumbers;
                                  formik.setFieldValue("repeated_trading_wallet_per_hour", s);
                                }}
                              />
                              <div
                                style={{ bottom: 10, right: 20 }}
                                className="position-absolute fw-medium text-secondary"
                              >
                                {t('trades within 1 hour')}
                              </div>
                            </div>
                            {formik.touched.repeated_trading_wallet_per_hour && formik.errors.repeated_trading_wallet_per_hour ? (
                              <div className="text-danger mt-2">{formik.errors.repeated_trading_wallet_per_hour}</div>
                            ) : null}
                          </Col>

                          <Col sm={12} md={12} xl={12} className='mt-4 pt-13 mb-3 text-end'>
                            <button
                              style={{ width: '150px' }}
                              type="submit"
                              disabled={(isLoading)}
                              className="btn btn-primary fs-14 rounded-pill bg-[#009ef7] hover:bg-[#0086d2]">
                              {(isLoading) ? <Spinner size="sm me-2" ></Spinner> : <>{t('Button Update')}</>}
                            </button>
                          </Col>
                        </div>
                      </Row>
                    </div>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* <Modal
          isOpen={!!isOpen}
          centered={true}
          // size="lg"
          toggle={() => setIsOpen(false)}
          keyboard={true}
        >
          <ModalHeader>
            {t('Alert Settings')}
          </ModalHeader>

          <ModalBody className="">
            <div className="row g-4">
              <Col sm={12}>
                <div className="row g-3">
                  <div className="mt-3 text-center">
                    <h6 className="mb-2 fs-19 text-center mt-1">
                      {t("Are you sure you want to update this?")}
                    </h6>
                    <p className="fs-15 mb-4 d-flex justify-content-center align-items-start align-items-sm-center text-center ">
                      {t('After confirming the update action, the data will be updated. Do you want to proceed with the update action.')}
                    </p>
                    <div className="d-flex gap-3 mt-2 justify-content-center">
                      <button
                        className="btn btn-primary rounded-pill fs-14 bg-[#009ef7] hover:bg-[#0086d2]"
                        type="button"
                        color="light"
                        onClick={() => handleSubmitConfiguration(formik?.values)}
                        style={{ width: '120px' }}
                      >
                        {(isLoading) ? <Spinner size="sm me-2" ></Spinner> : <>{t('Button Update')}</>}
                      </button>
                      <button
                        className="btn btn-secondary rounded-pill fs-14 ms-2 bg-[#878a99] hover:bg-[#737582]"
                        type="button"
                        color="light"
                        onClick={() => setIsOpen(false)}
                        style={{ width: '120px' }}
                      >
                        {t("Button Close")}
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          </ModalBody>
        </Modal > */}

        <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={2000} limit={2} />

      </div >
    </React.Fragment >
  );
};

export default AlertSetting;